import { useLazyLoadQuery } from "react-relay"
import type { chDuplicatePatientsByPatientIdQuery as ChQueryType } from "@/modules/patients/detail/duplicate-profiles/services/__generated__/chDuplicatePatientsByPatientIdQuery.graphql"
import type { deDuplicatePatientsByPatientIdQuery as DeQueryType } from "@/modules/patients/detail/duplicate-profiles/services/__generated__/deDuplicatePatientsByPatientIdQuery.graphql"
import { chDuplicatePatientsByPatientIdQuery } from "@/modules/patients/detail/duplicate-profiles/services/chDuplicatePatientsByPatientIdQuery"
import { deDuplicatePatientsByPatientIdQuery } from "@/modules/patients/detail/duplicate-profiles/services/deDuplicatePatientsByPatientIdQuery"
import { useCountryParam } from "@/modules/patients/hooks/useCountryParam"

function useDuplicatePatientsByPatientIdQuery(patientId: string) {
  const country = useCountryParam()
  const query = country === "CH" ? chDuplicatePatientsByPatientIdQuery : deDuplicatePatientsByPatientIdQuery

  const data = useLazyLoadQuery<ChQueryType | DeQueryType>(query, { patientId })

  const duplicatePatients =
    "ch_duplicatePatientsByPatientId" in data
      ? data.ch_duplicatePatientsByPatientId
      : data.de_duplicatePatientsByPatientId

  return duplicatePatients
}

export { useDuplicatePatientsByPatientIdQuery }
